import React from 'react';

const PageTitleAbout = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large">Despre Noi</h1>
            </div>
        </div>
    );
};

export default PageTitleAbout;
